module.exports = __webpack_public_path__ + "img/about/80243-040.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-040.png
// module id = 38
// module chunks = 0